"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useErrorBoxClass;

var _useWebChatAPIContext2 = _interopRequireDefault(require("./useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useErrorBoxClass() {
  var _useWebChatAPIContext = (0, _useWebChatAPIContext2.default)(),
      internalErrorBoxClass = _useWebChatAPIContext.internalErrorBoxClass;

  return [internalErrorBoxClass];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ob29rcy9pbnRlcm5hbC91c2VFcnJvckJveENsYXNzLmpzIl0sIm5hbWVzIjpbInVzZUVycm9yQm94Q2xhc3MiLCJpbnRlcm5hbEVycm9yQm94Q2xhc3MiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7OztBQUVlLFNBQVNBLGdCQUFULEdBQTRCO0FBQ3pDLDhCQUFrQyxxQ0FBbEM7QUFBQSxNQUFRQyxxQkFBUix5QkFBUUEscUJBQVI7O0FBRUEsU0FBTyxDQUFDQSxxQkFBRCxDQUFQO0FBQ0QiLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB1c2VXZWJDaGF0QVBJQ29udGV4dCBmcm9tICcuL3VzZVdlYkNoYXRBUElDb250ZXh0JztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlRXJyb3JCb3hDbGFzcygpIHtcbiAgY29uc3QgeyBpbnRlcm5hbEVycm9yQm94Q2xhc3MgfSA9IHVzZVdlYkNoYXRBUElDb250ZXh0KCk7XG5cbiAgcmV0dXJuIFtpbnRlcm5hbEVycm9yQm94Q2xhc3NdO1xufVxuIl19